export default __webpack_public_path__ + "static/media/login_logo.0d47d8cc.png";